module.exports = __webpack_public_path__ + "img/xlhd_icon.4a694776.svg";